import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

/**
 * Shows the projected row label and, on desktop hover, a toolbar over the row
 * (same look as the resources listing). Each listing projects its own buttons
 * into the toolbar by marking them with the `rowHoverAction` attribute.
 * The host row must be `position: relative` so the toolbar can overlay the next cells.
 */
@Component({
    selector: 'app-row-hover-actions',
    templateUrl: './row-hover-actions.component.html',
    styleUrls: ['./row-hover-actions.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RowHoverActionsComponent {
    @HostBinding('class.with-actions')
    @Input()
    showActions = true;
}
